<template>
  <div>
    <div>
      <a-modal
        ref="modal"
        :title="modalHeader"
        :footer="null"
        class="permission-modal"
        v-model="visible"
        @ok="addPermission"
        @cancel="onCancel"
        okText="Create"
      >
        <a-row>
          <router-view ref="permissionView">
            <div slot="footer">
              <slot name="footerMenu"></slot>
            </div>
          </router-view>
        </a-row>
      </a-modal>
    </div>
  </div>
</template>

<script>
import { setTimeout } from "timers";
export default {
  data() {
    return {
      visible: true,
      form: this.$form.createForm(this, { name: "coordinated" })
    };
  },
  computed: {
    modalHeader() {
      if (this.$route.name === "roles-show") {
        return "🔐 Role Details";
      }
      return "🔏 Edit Role";
    },
    modalFooter() {
      if (this.$route.name === "roles-show") {
        return false;
      }
      return true;
    }
  },
  methods: {
    showModal() {
      this.visible = true;
    },
    addPermission(e) {},
    onCancel(e) {
      return this.$router.push({ name: "roles" });
    }
  },
  mounted() {

  }
};
</script>

<style lang="scss" >
</style>
